import {Grid, GridProps} from '@mui/material';
import React from 'react'
import {LocationCardRowLabel, LocationCardRowValue} from './styles';

interface LocationCardRowProps extends GridProps {
  label: string;
  value: string;

}

/**
 * Old Location Card Row
 * @param label
 * @param value
 * @param props
 * @constructor
 * @deprecated
 */
const LocationCardRow = ({
  label,
  value,
  ...props
}: LocationCardRowProps) => {
  return (
    <Grid item {...props}>
      <LocationCardRowLabel variant="body1">
        {label}
      </LocationCardRowLabel>
        <LocationCardRowValue variant="body1">{value}</LocationCardRowValue>
    </Grid>
  );
};

export default LocationCardRow
